import React from 'react';
//import { PropTypes } from 'prop-types';

import StartCard from './StartCard';
import InspectorCard from './InspectorCard';
import TeamCard from './TeamCard';
import TeammemberCard from './TeammemberCard';
import InspectionCard from './InspectionCard';
import ItemCard from './ItemCard';
// import AccessCard from './AccessCard';
import SendCard from './SendCard';
import CloseCard from './CloseCard';

const cards = {
  start: <StartCard name='start' />,
  // inspector: <InspectorCard name='inspector' />,
  team: <TeamCard name='team' />,
  teammember: <TeammemberCard name='teammember' />,
  monitoring: <InspectionCard name='monitoring' />,
  item: <ItemCard name='item' />,
  // access: <AccessCard name='access' />,
  send: <SendCard name='send' />,
  close: <CloseCard name='close' />,
};

const list = [
  'start',
  // 'inspector',
  'team',
  // 'teammember',
  'monitoring',
  'item',
  // 'access',
  'send',
  'close',
];
const wizard = { cards, list };

export { cards, list };

export default wizard;
